/* SBI CUSTOM - tumbled stones bulk order page (sbi-tumbled-stones-page). Loaded with defer by sections/sbi-tumble-bulk.liquid,
   AFTER assets/sbi-tumble-math.js (window.SBITumble = the retailer maths, same rules as the product pages).
   Adapted from assets/sbi-bead-bulk.js (sbi-bead-bracelets). Rows are server-rendered (250 products per page; other pages
   are fetched with the Section Rendering API and merged). This adds the per-stone maths, filters, sort, ticks, steppers,
   +3/+5, and a dock that adds everything with ONE /cart/add.js call (items[]).
   URL presets: ?q=amethyst&size=m&for=Calm&col=Purple&instock=0 (used by links from the collection + product pages). */
(function () {
  var root = document.querySelector('[data-tb]');
  if (!root || root.__tb) return;
  root.__tb = true;

  var T = window.SBITumble || null;
  var rowsWrap = root.querySelector('[data-tb-rows]');
  var rows = [];
  var dock = root.querySelector('[data-tb-dock]');
  var btnAll = root.querySelector('[data-tb-addall]');
  var selInt = root.querySelector('[data-tb-int]'), selCol = root.querySelector('[data-tb-col]');
  var state = { q: '', size: 'all', int: 'all', col: 'all', instock: true, sort: 'rank', tick: 1 };
  var KEY = 'sbiTumbleBulk';
  var WS = root.getAttribute('data-ws') === '1', MATH = root.getAttribute('data-math') === '1';
  var MF = parseFloat(root.getAttribute('data-mfactor')) || 0.5;

  function money(c) { return '$' + (Math.round(c) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function dollars(x) { if (x == null || isNaN(x)) return '-'; var d = x < 1 ? 2 : (Math.abs(x - Math.round(x)) < 0.005 ? 0 : 2); return '$' + x.toFixed(d); }
  function store(v) { try { if (v === undefined) return JSON.parse(sessionStorage.getItem(KEY) || '{}'); sessionStorage.setItem(KEY, JSON.stringify(v)); } catch (e) { return {}; } }
  function qtyInput(r) { return r.querySelector('[data-tb-qty]'); }
  function maxOf(r) { var m = parseInt(r.getAttribute('data-max'), 10); return isNaN(m) ? 99 : Math.max(0, m); }
  function A(r, k) { return r.getAttribute(k) || ''; }

  /* --- per-row setup: size key + retailer maths (same functions the product page uses) --- */
  function sizeKey(r) {
    if (A(r, 'data-bundle') === '1') return 'bundle';
    var vt = A(r, 'data-vt');
    if (/assorted/i.test(vt)) return 'other';
    var t = T ? (T.tier(vt) || (vt === 'Default Title' ? T.tier(A(r, 'data-t')) : null)) : null;
    return t || 'other';
  }
  function prep(r) {
    if (r.__prep) return;
    r.__prep = true;
    r.setAttribute('data-size', sizeKey(r));
    if (!T || !MATH || A(r, 'data-m') !== '1') return;
    var v = { n: A(r, 'data-n'), t: A(r, 'data-vt') };
    var p = { n: A(r, 'data-pn'), single: !!A(r, 'data-pn'), sold: A(r, 'data-sold'), title: A(r, 'data-t'), stone: A(r, 'data-stone') };
    var st = null;
    try { st = T.stones(v, p); } catch (e) {}
    var cell = r.querySelector('[data-tb-math]'), stonesEl = r.querySelector('[data-tb-stones]');
    if (!st) { cell.innerHTML = '<small class="sbi-tb__muted">-</small>'; return; }
    var t = T.tier(v.t) || T.tier(p.title);
    if (st.pack && st.lo === 1) t = 'single';
    var pc = parseFloat(A(r, 'data-p')) || 0, cc = parseFloat(A(r, 'data-c')) || 0;
    var bag = (WS ? pc : Math.max(pc, cc)) / 100 * MF;
    var m = T.math(bag, st, t);
    var range = st.lo + (st.hi !== st.lo ? '-' + st.hi : '');
    if (stonesEl && !st.pack) stonesEl.textContent = (st.approx ? '~' : '') + range + ' stones per bag';
    if (!m) { cell.innerHTML = '<small class="sbi-tb__muted">-</small>'; return; }
    r.setAttribute('data-cps', m.cost.toFixed(4));
    cell.innerHTML = '<b>' + (st.approx ? '~' : '') + dollars(m.cost) + '</b><span>sell ' + dollars(m.retail) + '</span>';
  }

  function setQty(r, n, quiet) {
    var i = qtyInput(r); if (!i) return;
    var max = maxOf(r), q = Math.max(0, Math.min(isNaN(n) ? 0 : n, max));
    i.value = q;
    var t = r.querySelector('[data-tb-tick]'); if (t) t.checked = q > 0;
    r.classList.toggle('is-picked', q > 0);
    if (!quiet && n > max && max > 0) toast('Only ' + max + ' available for that one, so we set it to ' + max + '.', true);
    sum();
  }

  function sum() {
    var n = 0, styles = 0, total = 0, sel = {};
    rows.forEach(function (r) {
      var i = qtyInput(r); if (!i) return;
      var q = parseInt(i.value, 10) || 0;
      if (q > 0) { n += q; styles += 1; total += q * parseFloat(r.getAttribute('data-price')); sel[r.getAttribute('data-vid')] = q; }
    });
    root.querySelector('[data-tb-n]').textContent = n;
    root.querySelector('[data-tb-nlabel]').textContent = n === 1 ? 'item' : 'items';
    root.querySelector('[data-tb-styles]').textContent = styles;
    root.querySelector('[data-tb-total]').textContent = money(total);
    btnAll.disabled = n === 0;
    dock.classList.toggle('is-on', n > 0);
    dock.setAttribute('aria-hidden', n > 0 ? 'false' : 'true');
    /* the theme's back-to-top button (fixed, bottom centre, z-index 1300) sits on top of 'Add all to cart' on phones */
    document.documentElement.classList.toggle('sbi-tb-dock-on', n > 0);
    if (ready) store(sel);
  }

  /* sold-out sizes arrive as JSON (script[data-tb-o], one per product) and become rows only when someone
     switches "In stock only" off, so the page stays light */
  function esc(x) { return String(x == null ? '' : x).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function buildOut() {
    var frag = document.createDocumentFragment(), box = document.createElement('div');
    root.querySelectorAll('script[data-tb-o]:not([data-done])').forEach(function (s) {
      s.setAttribute('data-done', '1');
      var d; try { d = JSON.parse(s.textContent); } catch (e) { return; }
      var P = d.p;
      (d.v || []).forEach(function (v) {
        box.innerHTML = '<div class="sbi-tb__r is-out' + (P.b ? ' is-bundle' : '') + '" role="row" data-row data-vid="' + v.v + '" data-rank="' + v.r + '" data-int="' + esc(P.i) + '" data-col="' + esc(P.c) +
          '" data-name="' + esc(P.n + ' ' + String(v.z).toLowerCase()) + '" data-sort="' + esc(P.s) + '" data-price="' + v.pr + '" data-stock="0" data-max="0" data-instock="0" data-bundle="' + P.b +
          '" data-m="0" data-t="' + esc(P.t) + '" data-vt="' + esc(v.vt) + '"' + (v.im ? ' data-img="' + esc(v.im) + '"' : '') + '>' +
          '<span role="cell" class="c-tick"></span><span role="cell" class="c-item"><a class="sbi-tb__img" href="' + esc(v.u) + '" tabindex="-1" aria-hidden="true"></a><span class="sbi-tb__txt"><a class="sbi-tb__name" href="' + esc(v.u) + '">' + esc(P.d) + '</a><span class="sbi-tb__size"><b>' + esc(v.z) + '</b></span></span></span>' +
          '<span role="cell" class="c-price">' + v.ph + '</span><span role="cell" class="c-math"></span><span role="cell" class="c-stock"><b class="s-out">Sold out</b></span><span role="cell" class="c-qty"><a class="sbi-tb__view" href="' + esc(v.u) + '">View</a></span></div>';
        frag.appendChild(box.firstChild);
      });
    });
    rowsWrap.appendChild(frag);
    rows = Array.prototype.slice.call(rowsWrap.querySelectorAll('[data-row]'));
    rows.forEach(prep);
    sortRows();
  }

  /* sold-out rows ship without an <img> (page weight); add it the first time the row is shown */
  function showImg(r) {
    var a = r.querySelector('.sbi-tb__img'), src = r.getAttribute('data-img');
    r.removeAttribute('data-img');
    if (!a || !src || a.firstChild) return;
    var im = document.createElement('img');
    im.src = src; im.width = 80; im.height = 80; im.loading = 'lazy'; im.alt = '';
    a.appendChild(im);
  }

  function has(list, val) { return ('|' + list + '|').indexOf('|' + val + '|') > -1; }
  function apply() {
    var q = state.q.trim().toLowerCase(), shown = 0;
    rows.forEach(function (r) {
      var ok = true;
      if (q && A(r, 'data-name').indexOf(q) === -1) ok = false;
      if (ok && state.size !== 'all' && A(r, 'data-size') !== state.size) ok = false;
      if (ok && state.int !== 'all' && !has(A(r, 'data-int'), state.int)) ok = false;
      if (ok && state.col !== 'all' && !has(A(r, 'data-col'), state.col)) ok = false;
      if (ok && state.instock && A(r, 'data-instock') !== '1') ok = false;
      r.classList.toggle('is-hidden', !ok);
      if (ok) { shown += 1; if (r.hasAttribute('data-img')) showImg(r); }
    });
    root.querySelector('[data-tb-shown]').innerHTML = shown + ' of ' + rows.length + '<span class="sbi-tb__lg"> shown</span>';
    root.querySelector('[data-tb-empty]').hidden = shown !== 0 || !ready;
  }

  function sortRows() {
    var k = state.sort, s = rows.slice();
    var num = function (r, a, d) { var x = parseFloat(r.getAttribute(a)); return isNaN(x) ? d : x; };
    s.sort(function (a, b) {
      if (k === 'name') return A(a, 'data-sort').localeCompare(A(b, 'data-sort')) || num(a, 'data-rank', 0) - num(b, 'data-rank', 0);
      if (k === 'price-asc') return num(a, 'data-price', 0) - num(b, 'data-price', 0) || num(a, 'data-rank', 0) - num(b, 'data-rank', 0);
      if (k === 'price-desc') return num(b, 'data-price', 0) - num(a, 'data-price', 0) || num(a, 'data-rank', 0) - num(b, 'data-rank', 0);
      if (k === 'cps') return num(a, 'data-cps', 1e9) - num(b, 'data-cps', 1e9) || num(a, 'data-rank', 0) - num(b, 'data-rank', 0);
      if (k === 'stock') return num(b, 'data-stock', 0) - num(a, 'data-stock', 0);
      return num(a, 'data-rank', 0) - num(b, 'data-rank', 0);
    });
    var frag = document.createDocumentFragment();
    s.forEach(function (r) { frag.appendChild(r); });
    rowsWrap.appendChild(frag);
  }

  /* intention + colour dropdowns are built from the rows, so they only offer values that exist */
  function fillSelect(sel, attr, keep) {
    var seen = {};
    rows.forEach(function (r) { A(r, attr).split('|').forEach(function (x) { if (x) seen[x] = (seen[x] || 0) + 1; }); });
    var vals = Object.keys(seen).sort(function (a, b) { return a.localeCompare(b); });
    var first = sel.options[0];
    sel.innerHTML = '';
    sel.appendChild(first);
    vals.forEach(function (x) { var o = document.createElement('option'); o.value = x; o.textContent = x; sel.appendChild(o); });
    sel.value = vals.indexOf(keep) > -1 ? keep : 'all';
    sel.closest('label').hidden = vals.length === 0;
    return sel.value;
  }

  function pick(groupSel, attr, val) {
    root.querySelectorAll(groupSel + ' button').forEach(function (b) {
      var on = b.getAttribute(attr) === val;
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  var toastEl = root.querySelector('[data-tb-toast]');
  function toast(msg, err, cartLink) {
    toastEl.innerHTML = '';
    toastEl.appendChild(document.createTextNode(msg));
    if (cartLink) { var a = document.createElement('a'); a.href = '/cart'; a.textContent = 'View cart'; toastEl.appendChild(a); }
    toastEl.classList.toggle('is-err', !!err);
    toastEl.hidden = false;
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.hidden = true; }, err ? 6000 : 4500);
  }

  function refreshCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-js-cart-count], [data-cart-count], .cart-count-bubble span').forEach(function (el) { el.textContent = c.item_count; });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: c } }));
      document.dispatchEvent(new CustomEvent('theme:cart:reload'));
    }).catch(function () {});
  }

  function post(items) {
    /* SBI CUSTOM (sbi-bead-strands-bulk 2026-10-18): attribution - hidden line-item property _bulk = 'tumbled' on every line added
       here; it stays on the order line (Admin API lineItems.customAttributes), counted by sbi-bead-strands-bulk/scripts/bulk_usage.py */
    items = items.map(function (it) { return { id: it.id, quantity: it.quantity, properties: { _bulk: 'tumbled' } }; });
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || 'Could not add to cart'); e.status = r.status; throw e; } return j; }); });
  }

  /* --- events --- */
  root.addEventListener('click', function (e) {
    var t = e.target;
    var b = t.closest('[data-size]');
    if (b && b.tagName === 'BUTTON') { state.size = b.getAttribute('data-size'); pick('[data-tb-sizes]', 'data-size', state.size); apply(); return; }
    b = t.closest('[data-tb-tickqty] button');
    if (b) { state.tick = parseInt(b.getAttribute('data-n'), 10) || 1; pick('[data-tb-tickqty]', 'data-n', String(state.tick)); return; }
    var r = t.closest('[data-row]');
    if (r && t.closest('[data-tb-inc]')) { setQty(r, (parseInt(qtyInput(r).value, 10) || 0) + 1); return; }
    if (r && t.closest('[data-tb-dec]')) { setQty(r, (parseInt(qtyInput(r).value, 10) || 0) - 1, true); return; }
    b = t.closest('[data-tb-add]');
    if (r && b) { setQty(r, (parseInt(qtyInput(r).value, 10) || 0) + parseInt(b.getAttribute('data-tb-add'), 10)); return; }
    if (t.closest('[data-tb-reset]')) { reset(); return; }
    if (t.closest('[data-tb-clear]')) { rows.forEach(function (x) { setQty(x, 0, true); }); return; }
  });
  root.addEventListener('change', function (e) {
    var t = e.target, r = t.closest('[data-row]');
    if (t.matches('[data-tb-tick]') && r) { setQty(r, t.checked ? Math.max(parseInt(qtyInput(r).value, 10) || 0, state.tick) : 0); return; }
    if (t.matches('[data-tb-qty]') && r) { setQty(r, parseInt(t.value, 10) || 0); return; }
    if (t.matches('[data-tb-instock]')) { state.instock = t.checked; if (!t.checked) buildOut(); apply(); return; }
    if (t.matches('[data-tb-sort]')) { state.sort = t.value; sortRows(); return; }
    if (t === selInt) { state.int = t.value; apply(); return; }
    if (t === selCol) { state.col = t.value; apply(); return; }
  });
  var qIn = root.querySelector('[data-tb-q]'), qT;
  qIn.addEventListener('input', function () { clearTimeout(qT); qT = setTimeout(function () { state.q = qIn.value; apply(); }, 120); });

  function reset() {
    state.q = ''; qIn.value = ''; state.size = 'all'; state.int = 'all'; state.col = 'all'; state.instock = false;
    root.querySelector('[data-tb-instock]').checked = false;
    selInt.value = 'all'; selCol.value = 'all'; buildOut();
    pick('[data-tb-sizes]', 'data-size', 'all'); apply();
  }

  btnAll.addEventListener('click', function () {
    var items = [], picked = [];
    rows.forEach(function (r) {
      var i = qtyInput(r), q = i ? parseInt(i.value, 10) || 0 : 0;
      if (q > 0) { items.push({ id: +r.getAttribute('data-vid'), quantity: q }); picked.push(r); }
    });
    if (!items.length) return;
    btnAll.disabled = true; btnAll.textContent = 'Adding...';
    var total = items.reduce(function (a, b) { return a + b.quantity; }, 0);
    var done = function (added, failed) {
      btnAll.textContent = 'Add all to cart';
      picked.forEach(function (r) { if (failed.indexOf(r) === -1) setQty(r, 0, true); });
      refreshCart();
      if (failed.length) {
        toast('Added ' + added + ' items. ' + failed.length + ' could not be added (stock changed); they are still ticked.', true, true);
      } else {
        toast('Added ' + added + ' items to your cart.', false, true);
      }
      sum();
    };
    post(items).then(function () { done(total, []); }).catch(function () {
      /* one bad line rejects the whole call: fall back to one call per line so the rest still lands */
      var added = 0, failed = [], chain = Promise.resolve();
      items.forEach(function (it, k) {
        chain = chain.then(function () { return post([it]).then(function () { added += it.quantity; }).catch(function () { failed.push(picked[k]); }); });
      });
      chain.then(function () { done(added, failed); });
    });
  });

  /* --- start --- */
  var ready = false;
  var u = new URLSearchParams(location.search);
  if (u.get('q')) { state.q = u.get('q'); qIn.value = state.q; }
  if (u.get('size')) { state.size = u.get('size'); pick('[data-tb-sizes]', 'data-size', state.size); }
  if (u.get('for')) state.int = u.get('for');
  if (u.get('col')) state.col = u.get('col');
  if (u.get('instock') === '0') { state.instock = false; root.querySelector('[data-tb-instock]').checked = false; }

  function collect() {
    rows = Array.prototype.slice.call(rowsWrap.querySelectorAll('[data-row]'));
    rows.forEach(prep);
    state.int = fillSelect(selInt, 'data-int', state.int);
    state.col = fillSelect(selCol, 'data-col', state.col);
  }
  function finish() {
    ready = true;
    if (!state.instock) buildOut();
    var saved = store();
    rows.forEach(function (r) { var q = saved[r.getAttribute('data-vid')]; if (q) setQty(r, q, true); });
    sortRows(); apply(); sum();
  }

  collect(); sortRows(); apply(); sum();

  /* more than 250 products: fetch the other pages of this section and merge their rows */
  var pg = root.querySelector('[data-tb-pages]');
  var pages = pg ? parseInt(pg.getAttribute('data-tb-pages'), 10) || 1 : 1;
  var cur = pg ? parseInt(pg.getAttribute('data-tb-page'), 10) || 1 : 1;
  var sid = root.getAttribute('data-section');
  if (pages > 1 && sid && window.fetch) {
    var loading = root.querySelector('[data-tb-loading]');
    loading.hidden = false;
    var jobs = [];
    for (var k = 1; k <= pages; k++) {
      if (k === cur) continue;
      (function (n) {
        var url = location.pathname + '?page=' + n + '&section_id=' + encodeURIComponent(sid);
        jobs.push(fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
          var box = document.createElement('div');
          box.innerHTML = html;
          var got = box.querySelectorAll('[data-tb-rows] [data-row], [data-tb-rows] script[data-tb-o]');
          var frag = document.createDocumentFragment();
          Array.prototype.forEach.call(got, function (r) { frag.appendChild(r); });
          rowsWrap.appendChild(frag);
        }).catch(function () {}));
      })(k);
    }
    Promise.all(jobs).then(function () {
      loading.hidden = true;
      var np = rowsWrap.querySelector('noscript'); if (np) np.remove();
      collect(); finish();
    });
  } else {
    finish();
  }
})();
